(function () {
  /*Example of HTML:
    <div>
      <h2>Headline</h2>
      <p>Some text</p>
      <div id="more-1" class="full-content" aria-hidden="true">
        <p>Some more text</p>
      </div>
      <button aria-expanded="false" aria-controls="more-1" class="toggle-content"><span class="text">More details</span> <span class="sr-only">about Headline</span></button>
    </div>
  */
  document.addEventListener("click", function (event) {
    const toggler = event.target.closest(".toggle-content");
    if (toggler) {
      const fullContentId = toggler.getAttribute("aria-controls");
      const fullContentWrapper = document.getElementById(fullContentId);
      const toggleContainer = toggler.closest(".full-content-container");
      const toggleButtonText = toggler.querySelector(".text");
      const updateText = toggler.dataset.text;
      const isInTitle = toggler.closest(".full-content-title");

      if (isInTitle) {
        // Apply animation styles only for title togglers
        fullContentWrapper.style.transition = "max-height 0.3s ease-in-out";
        fullContentWrapper.style.overflow = "hidden";
      }

      // change attributes and text if full text is shown/hidden
      if (!fullContentWrapper.hasAttribute("hidden")) {
        if (isInTitle) {
          // Slide Up animation only for title togglers
          const currentHeight = fullContentWrapper.scrollHeight;
          fullContentWrapper.style.maxHeight = currentHeight + "px";
          fullContentWrapper.offsetHeight; // Trigger reflow
          fullContentWrapper.style.maxHeight = "0px";

          // Wait for animation to complete before hiding
          setTimeout(() => {
            if (updateText) toggleButtonText.textContent = "More details";
            fullContentWrapper.setAttribute("hidden", true);
            fullContentWrapper.setAttribute("aria-hidden", true);
            toggler.setAttribute("aria-expanded", false);
            if (toggleContainer && isInTitle) {
              toggleContainer.classList.remove("open");
              if (toggler.classList.contains("btn-activity")) {
                toggler.textContent = "View";
              }
            }
          }, 300);
        } else {
          // Immediate hide for non-title togglers
          if (updateText) toggleButtonText.textContent = "More details";
          fullContentWrapper.setAttribute("hidden", true);
          fullContentWrapper.setAttribute("aria-hidden", true);
          toggler.setAttribute("aria-expanded", false);
        }
      } else {
        if (isInTitle) {
          // Slide Down animation only for title togglers
          if (updateText) toggleButtonText.textContent = updateText;
          fullContentWrapper.removeAttribute("hidden");
          fullContentWrapper.style.maxHeight = "0px";
          fullContentWrapper.offsetHeight; // Trigger reflow
          const contentHeight = fullContentWrapper.scrollHeight;
          fullContentWrapper.style.maxHeight = contentHeight + "px";

          toggler.setAttribute("aria-expanded", true);
          fullContentWrapper.setAttribute("aria-hidden", false);
          if (toggleContainer) {
            toggleContainer.classList.add("open");
            if (toggler.classList.contains("btn-activity")) {
              toggler.textContent = "Close";
            }
          }

          // Remove max-height after animation completes
          setTimeout(() => {
            fullContentWrapper.style.maxHeight = "none";
          }, 300);
        } else {
          // Immediate show for non-title togglers
          if (updateText) toggleButtonText.textContent = updateText;
          fullContentWrapper.removeAttribute("hidden");
          toggler.setAttribute("aria-expanded", true);
          fullContentWrapper.setAttribute("aria-hidden", false);
        }
      }
    }
  });
})();
